import styled, { css } from 'styled-components';

import { BodyLargeMedium, BodySmallRegular, Colour } from '@xemplo/style-constants';

const flexCenter = css`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background: ${Colour.Gray[100]};
`;
export const Container = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  ${flexCenter};
`;

export const ContentWrapper = styled.div`
  ${flexCenter};
  gap: 40px;
  padding-bottom: 32px;
`;

export const Content = styled.div`
  ${flexCenter};
  gap: 16px;
`;

export const Title = styled.span`
  ${BodyLargeMedium};
  color: ${Colour.Gray[500]};
`;
export const Subtitle = styled.span`
  ${BodySmallRegular};
  color: ${Colour.Gray[400]};
`;
